import { FilterButton } from '../filter';

export const DataTableFilterButton = FilterButton;
